export const isFullStatic = false
export const staticPath = "/home/webuser/www/megasreda/frontend-v2/releases/20240313112438/_megasreda/static-json"
export const publicPath = "/"
export const globalContext = "__MEGASREDA__"
export const globalNuxt = "$megasreda"